export default "__VITE_ASSET__Cgg61MEe__"